export enum APIRequestResources {
  AuthenticationService = 'auth',
  EmployeeService = 'employee',
  MealService = 'lunch',
  Restriction = 'restriction',
  FOODITEMSERVICE = 'food-item',
  CostService = 'cost',
}

